module.exports = __webpack_public_path__ + "img/icon-warning-triangle.e5bf9b63.svg";